import { render, staticRenderFns } from "./FlexibleTemplatePreview.vue?vue&type=template&id=81e5605a"
import script from "./FlexibleTemplatePreview.vue?vue&type=script&lang=js"
export * from "./FlexibleTemplatePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports